<template>
  <Modal :title="$t('global.add-pointer-domain')" @close="close" :hide-footer="true">
    <template #body>
      <AddPointerDomainForm
        :site="data.site"
        :types="pointerDomainTypes"
        @cancel="close"
        @success="close"
      />
    </template>
  </Modal>
</template>
<script>
import AddPointerDomainForm from "@/components/smart/forms/AddPointerDomainForm";
import { computed } from "@vue/composition-api";
import Modal from "@/components/display/Modal";
import store from "@/store";

export default {
  name: "PointerDomainAddModal",
  components: {
    AddPointerDomainForm,
    Modal,
  },
  props: {
    data: Object,
    validator: (value) => {
      return !!value.site && typeof value.site === "object";
    },
  },
  setup(props, { emit }) {
    const pointerDomainTypes = computed(() => store.getters["pointerDomains/getTypeList"]);

    const close = () => {
      emit("close");
    };

    return {
      close,
      pointerDomainTypes,
    };
  },
};
</script>
